import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-square-check",
  "use": "icon-square-check-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol fill=\"currentColor\" class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-square-check\"><path d=\"M896 0H128C57.6 0 0 57.6 0 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128V128c0-70.4-57.6-128-128-128zM448 794.496L210.752 557.248l90.496-90.496L448 613.504l306.752-306.752 90.496 90.496L448 794.496z\" p-id=\"13008\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol